import {
  postData,
  getData,
  deleteData
} from './request'
import {
  accountApiUrl
} from '../../../src/config';

// check是否登录
export function checkLogin(paload, cb) {
  postData(`${accountApiUrl}/p/auth/check`, paload, {}, cb)
}

// 退出登录
export function logout(paload, cb) {
  postData(`${accountApiUrl}/p/logout`, paload, {}, cb)
}


// 创建文件夹
export function createFolder(paload, cb) {
  postData(`/api/v3/groups/${paload.groupid}/files`, paload, {}, cb)
}

// 获取grouoid
export function loadGroup(paload, cb) {
  getData(`/api/v3/groups`, {}, cb)
}

// 搜索
export function search(paload, cb) {
  getData(`/api/v3/search/files?count=5&offset=0&searchname=${encodeURIComponent(paload)}`, {}, cb)
}

// 批量删除不同组的文件
export function deleteGroupsFile(paload,cb){
  postData(`/api/v3/files/multi/delete`, paload, {}, cb)
}

// 加载配置
export function loadConfig(cb){
  getData(`/api/user/configs`, {}, cb)
}


// WEBPACK FOOTER //
// ./src/store/service/common.js